export function MfeMount() {
  return <div id="single-spa-app-container" className="h-full" />;
}
